






































import Vue from "vue";

import LoginCard from "@/components/Account/LoginCard.vue";

export default Vue.extend({
  components: {
    LoginCard
  }
});
